'use client';

import { Heading } from '@app/app/_components/Heading/Heading';
import { CheckoutResult } from '@app/domain/model/checkout/CheckoutResult';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

interface Props {
    checkoutResult?: CheckoutResult;
}

export function GatewayRedirectStep({ checkoutResult }: Props) {
    const t = useTranslations();

    useEffect(() => {
        if (checkoutResult?.redirectUrl == null) {
            return;
        }

        window.location.href = checkoutResult.redirectUrl;
    }, [checkoutResult?.redirectUrl]);

    return (
        <div className="flex flex-col items-center py-4 md:py-8">
            <div className="mb-12 mt-6 flex flex-col gap-2 text-center">
                <Heading>{t('eshop.general.redirecting')}</Heading>
                <div>{t('eshop.general.redirectingDescription')}</div>
            </div>
        </div>
    );
}
